/* Runtime configuration. Everything here is public by design — see .env.example. */

export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || ''
export const SUPABASE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || ''

/** True once the project is wired to a real backend. Until then the app runs on
    the bundled sample records so a fresh clone still shows a working map. */
export const HAS_BACKEND = Boolean(SUPABASE_URL && SUPABASE_KEY)

/* OpenFreeMap serves the full planet from OpenStreetMap data with no API key,
   no rate limit and no tracking, which is the right default for a project that
   wants to still be running in ten years. Swap via VITE_MAP_STYLE_URL. */
export const MAP_STYLE =
  import.meta.env.VITE_MAP_STYLE_URL || 'https://tiles.openfreemap.org/styles/liberty'

/* Glyph endpoint for our own symbol layers. Needed because the raster basemaps
   (Lands Department, aerial imagery) are hand-built styles with no glyphs of
   their own, and a symbol layer without a glyph source silently renders nothing.

   LABEL_FONT is not decoration either: MapLibre's default text-font is
   ["Open Sans Regular", "Arial Unicode MS Regular"], and this endpoint serves
   neither — it 404s. Chinese still appears, because localIdeographFontFamily
   draws CJK from a local system font, which is exactly what makes the bug hard
   to see: on a Hong Kong map the Chinese looks fine while every Latin label
   quietly vanishes. Keep these two in step with each other. */
export const GLYPHS =
  import.meta.env.VITE_GLYPHS_URL ||
  'https://tiles.openfreemap.org/fonts/{fontstack}/{range}.pbf'

export const LABEL_FONT = ['Noto Sans Regular']

/* Victoria Harbour, framed to hold both shores — the reclamation story is the
   space between them. */
export const INITIAL_VIEW = {
  center: [114.169, 22.297],
  zoom: 11.6,
  maxBounds: [[113.60, 22.05], [114.60, 22.65]],  // Hong Kong plus a margin
}

export const YEAR_MIN = 1841   // cession, and the first surveyed shoreline
export const YEAR_MAX = new Date().getFullYear()

export const KIND_COLOR = {
  story:      '#1f6f8b',
  relocation: '#c2701c',
  ecology:    '#4a7c59',
  place:      '#6b5b95',
}

export const MEDIA_BASE = HAS_BACKEND
  ? `${SUPABASE_URL}/storage/v1/object/public/media/`
  : ''

/* Null until a real repository exists. Deliberately not a placeholder string:
   a dead link in the About modal of a project whose whole pitch is "the code is
   open, go and check it" is worse than no link at all. Callers hide their link
   when this is null. Set VITE_REPO_URL at build time to switch it on. */
export const REPO_URL = import.meta.env.VITE_REPO_URL || null
